import { Component } from "react";
import { NSARouterMakerResult } from "namirasoft-account-react";
import { InfraLayout } from '../InfraLayout';
import { InfraEntities } from "../InfraEntities";
import { InfraRouterProps } from "../InfraRouterProps";

interface EnvironmentListPageProps extends NSARouterMakerResult, InfraRouterProps { }

export default class EnvironmentListPage extends Component<EnvironmentListPageProps>
{
    override render()
    {
        return (
            <InfraLayout
                {...this.props}
                pages={{
                    entity: InfraEntities.environment(this.props),
                    list: {}
                }}
            >
                <></>
            </InfraLayout>
        );
    }
}